
<router-outlet></router-outlet>
<div id="notifications-container"></div>